// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { embedDashboard } from "@superset-ui/embedded-sdk";
// import { useHistory } from "react-router-dom/cjs/react-router-dom";
// import { Card, CardContent, Typography, Grid, Button } from "@mui/material";
// import { toast } from "react-toastify";
// import "./Reports.scss";
// import AssessmentIcon from "@mui/icons-material/Assessment";
// import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";

// const iconMap = {
//   footfall: <AssessmentIcon fontSize="large" sx={{ color: "white" }} />,
//   finance: <MonetizationOnIcon fontSize="large" sx={{ color: "white" }} />,
// };

// const Dashboard = () => {
//   const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
//   const [accessToken, setAccessToken] = useState("");
//   const [guestToken, setGuestToken] = useState("");
//   const [selectedDashboard, setSelectedDashboard] = useState(null);
//   const [userRole, setUserRole] = useState("");
//   const history = useHistory();
//   const [dashboards, setDashboards] = useState([]);
//   const [authToken, setAuthToken] = useState(
//     sessionStorage.getItem("accessToken") !== undefined &&
//       sessionStorage.getItem("accessToken") !== null
//       ? sessionStorage.getItem("accessToken")
//       : ""
//   );
//   const headers = {
//     Authorization: `Bearer ${authToken}`,
//   };
//   // useEffect(() => {
//   //   toast.error(
//   //     "This is a Trial Version. Advanced Analytics require Enterprise License."
//   //   );
//   // }, []);
//   useEffect(() => {
//     axios
//       .get(`${REACT_APP_BACKEND_ROUTE_URL}get_logged_in_user_info/`, {
//         headers: headers,
//       })
//       .then((res) => {
//         const { dashboards: rawDashboards } = res.data;
//         // const transformed = rawDashboards.map((item) => {
//         //   const [name, id] = Object.entries(item)[0];
//         //   const cleanName = name.replace(/\s/g, "");
//         //   return {
//         //     id,
//         //     name,
//         //     icon: iconMap[cleanName] || null,
//         //   };
//         // });

//         const transformed = rawDashboards.map((item) => {
//           const [name, id] = Object.entries(item)[0];
//           const cleanName = name.replace(/\s/g, "").toLowerCase();
//           return {
//             id,
//             name,
//             icon: iconMap[cleanName] || null,
//           };
//         });
//         setDashboards(transformed);
//       })
//       .catch((err) => {
//         console.error("Failed to fetch dashboard info:", err);
//       });
//   }, []);

//   useEffect(() => {
//     const token = sessionStorage.getItem("accessToken");
//     const role = sessionStorage.getItem("roleType");
//     setUserRole(role);

//     if (!token) {
//       history.push("/login");
//     } else {
//       if (role !== "facility user") {
//         login();
//       }
//     }
//   }, []);

//   useEffect(() => {
//     if (accessToken && selectedDashboard) {
//       getGuestToken(accessToken, selectedDashboard.id);
//     }
//   }, [accessToken, selectedDashboard]);

//   useEffect(() => {
//     if (guestToken && selectedDashboard) {
//       embedSupersetDashboard(selectedDashboard.id);
//     }
//   }, [guestToken, selectedDashboard]);

//   const login = () => {
//     axios
//       .post(`https://superset.hlthtek.com/api/v1/security/login`, {
//         password: "admin",
//         provider: "db",
//         refresh: true,
//         username: "admin",
//       })
//       .then((res) => {
//         if (res.data?.access_token) setAccessToken(res.data.access_token);
//       })
//       .catch((err) => console.error("Login error:", err));
//   };

//   const getGuestToken = (accessToken, dashboardId) => {
//     axios
//       .post(
//         `https://superset.hlthtek.com/api/v1/security/guest_token/`,
//         {
//           user: {
//             username: "dashboard",
//             first_name: "dashboard",
//             last_name: "test",
//             roles: ["guest", "Public", "Gamma"],
//           },
//           resources: [{ type: "dashboard", id: dashboardId }],
//           rls: [],
//         },
//         { headers: { Authorization: `Bearer ${accessToken}` } }
//       )
//       .then((res) => {
//         if (res.data?.token) setGuestToken(res.data.token);
//       })
//       .catch((err) => console.error("Guest token error:", err));
//   };

//   const embedSupersetDashboard = (dashboardId) => {
//     embedDashboard({
//       id: dashboardId,
//       supersetDomain: "https://superset.hlthtek.com",
//       mountPoint: document.getElementById("dashboard"),
//       fetchGuestToken: () => guestToken,
//       dashboardUiConfig: { hideTitle: true, filters: true },
//     });
//   };

//   if (!selectedDashboard) {
//     if (userRole !== "facility user") {
//       return (
//         <Grid
//           container
//           spacing={3}
//           sx={{
//             p: { xs: 1, sm: 2, md: 3 },
//             width: "80%",
//             margin: "20px auto",
//             justifyContent: "center",
//             boxShadow: 3,
//             borderRadius: 2,
//           }}
//         >
//           {dashboards.map((item) => (
//             <Grid
//               item
//               xs={12}
//               sm={6}
//               md={4}
//               lg={3}
//               key={item.id}
//               onClick={() => setSelectedDashboard(item)}
//               sx={{
//                 padding: "24px",
//                 cursor: "pointer",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               <Card
//                 sx={{
//                   width: "100%",
//                   height: { xs: "170px", sm: "180px" },
//                   display: "flex",
//                   justifyContent: "center",
//                   boxShadow: 3,
//                   borderRadius: 2,
//                   transition: "transform 0.3s ease",
//                   backgroundColor: "#21cdc0",
//                   padding: 2,
//                   "&:hover": {
//                     transform: "scale(1.05)",
//                     backgroundColor: "#003366",
//                   },
//                 }}
//               >
//                 <CardContent sx={{ textAlign: "center" }}>
//                   <div style={{ marginBottom: "2rem" }}>{item.icon}</div>
//                   <Typography variant="h6" sx={{ color: "white" }}>
//                     {item.name}
//                   </Typography>
//                 </CardContent>
//               </Card>
//             </Grid>
//           ))}
//         </Grid>
//       );
//     } else {
//       return (
//         <Typography variant="h4" textAlign="center" mt={5}>
//           Your role does not have access to analytics.
//         </Typography>
//       );
//     }
//   }

//   return (
//     <div className="App" style={{ width: "100%", height: "100%" }}>
//       <div id="dashboard" className="embedded-superset" />
//     </div>
//   );
// };

// export default Dashboard;
import React from "react";

const Reports = () => {
  // Get values from session storage
  const orgCode = sessionStorage.getItem("ORG_CODE");
  const roleType = sessionStorage.getItem("roleType");

  // Determine role for URL
  const roleParam = roleType !== "facility user" ? "ADMIN" : "USER";

  // Base URL from env: use PROD when ABDM is connected with prod, else DEV
  const isProd = process.env.REACT_APP_IS_TIMELINE_CONNECTED_WITH_PROD === "true";
  const timelineBaseUrl = isProd
    ? process.env.REACT_APP_TIMELINE_BASE_URL_PROD
    : process.env.REACT_APP_TIMELINE_BASE_URL_DEV;

  // Build the URL dynamically
  const reportUrl = `${timelineBaseUrl || process.env.REACT_APP_TIMELINE_BASE_URL_DEV}?org=${orgCode}&role=ADMIN&u=ZmFjaWxpdHlfYWRtaW4=&p=I3RtNHRFdXNlcg==#/`;

  // // Build the URL dynamically
  // const reportUrl = `https://mis-dev.hlthtek.com/mis/?org=${orgCode}&role=ADMIN&u=ZmFjaWxpdHlfYWRtaW4=&p=I3RtNHRFdXNlcg==#/`;

  // Log URL to console
  console.log("Generated report URL:", reportUrl);

  return (
    <div style={{ width: "100%", height: "90vh" }}>
      <iframe
        src={reportUrl}
        title="Reports"
        width="100%"
        height="100%"
        style={{ border: "none" }}
      />
    </div>
  );
};

export default Reports;
